import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "list", "empty", "announcement"]
  static values = { inputName: { type: String, default: "client_role[sections][]" } }

  connect() {
    this.sections = Array.from(this.listTarget.querySelectorAll(":scope > li[data-section]"), row => row.dataset.section)
    this.render()
  }

  toggle(event) {
    const { value, checked } = event.target
    this.sections = checked ? [...this.sections, value] : this.sections.filter(section => section !== value)
    this.render()
    this.announcementTarget.textContent = `${event.target.dataset.label} ${checked ? "added" : "removed"}.`
  }

  move(event) {
    const { section, direction } = event.currentTarget.dataset
    const index = this.sections.indexOf(section)
    const nextIndex = index + Number(direction)
    if (nextIndex < 0 || nextIndex >= this.sections.length) return

    ;[this.sections[index], this.sections[nextIndex]] = [this.sections[nextIndex], this.sections[index]]
    this.render()
    const row = Array.from(this.listTarget.children).find(item => item.dataset.section === section)
    const buttons = Array.from(row.querySelectorAll("button"))
    const focusButton = buttons.find(button => button.dataset.direction === direction && !button.disabled) || buttons.find(button => !button.disabled)
    focusButton?.focus()
    this.announcementTarget.textContent = `${this.labelFor(section)} moved to position ${nextIndex + 1}.`
  }

  labelFor(section) {
    return this.checkboxTargets.find(checkbox => checkbox.value === section)?.dataset.label || section
  }

  render() {
    this.listTarget.replaceChildren()
    this.sections.forEach((section, index) => {
      const row = document.createElement("li")
      row.dataset.section = section
      row.className = "d-flex align-items-center gap-2 py-2"
      const label = document.createElement("span")
      label.className = "flex-grow-1"
      label.textContent = `${index + 1}. ${this.labelFor(section)}`
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = this.inputNameValue
      input.value = section
      row.append(input, label)

      ;[-1, 1].forEach(direction => {
        const button = document.createElement("button")
        button.type = "button"
        button.className = "btn btn-sm btn-outline-secondary flex-shrink-0"
        button.textContent = direction === -1 ? "↑" : "↓"
        button.setAttribute("aria-label", `Move ${this.labelFor(section)} ${direction === -1 ? "up" : "down"}`)
        button.dataset.action = "role-sections#move"
        button.dataset.section = section
        button.dataset.direction = direction
        button.disabled = index + direction < 0 || index + direction >= this.sections.length
        row.append(button)
      })
      this.listTarget.append(row)
    })
    this.emptyTarget.hidden = this.sections.length > 0
  }
}
